export default Object.freeze({
  EvaluacionInicial: 1,
  Therapy:3,
  EvaluacionAdicional: 2,
  EvaluacionTrianual: 10,
  Reevaluacion: 11,
})
